var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMogies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_8782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56211 17.1241L0.965681 17.1241C0.965681 17.1241 0.577449 6.06972 5.40255 8.73096C10.1167 6.37681 9.56211 17.1241 9.56211 17.1241Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3931 5.3066C10.3931 8.23736 8.0665 10.6132 5.19654 10.6132C4.17201 10.6132 3.21673 10.3104 2.41182 9.78773C0.961968 8.84622 0 7.19113 0 5.3066C0 2.37585 2.32657 0 5.19654 0C8.0665 0 10.3931 2.37585 10.3931 5.3066ZM5.1965 3.94204C5.1965 4.30489 4.90845 4.59905 4.55312 4.59905C4.19779 4.59905 3.90974 4.30489 3.90974 3.94204C3.90974 3.57918 4.19779 3.28503 4.55312 3.28503C4.90845 3.28503 5.1965 3.57918 5.1965 3.94204ZM8.41345 4.59905C8.76877 4.59905 9.05683 4.30489 9.05683 3.94204C9.05683 3.57918 8.76877 3.28503 8.41345 3.28503C8.05812 3.28503 7.77007 3.57918 7.77007 3.94204C7.77007 4.30489 8.05812 4.59905 8.41345 4.59905Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_8782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMogies);
export default __webpack_public_path__ + "static/media/icon-mogies.2eb20a55035b02aee3e3daefa0f34bd2.svg";
export { ForwardRef as ReactComponent };